import React from "react";
import { Form, Select } from "react-bootstrap";

function CustomSelect(props) {
  const {
    width,
    list,
    size,
    margin,
    height,
    handleChange,
    handleSubmit,
    name,
    placeholder,
    padding,
    display,
    alignItems,
    ...rest
  } = props;
  const [firstElem, ...restElem] = list;
  return (
    <div
      className={`${
        display !== undefined && alignItems !== undefined && "d-flex align-items-center"
      } w-100 h-100`}>
      <Form.Select
        name={name}
        size={size}
        style={{ width: width, height: height, padding: padding, margin: margin || 0 }}
        aria-label="Default select example"
        onChange={(e) => {
          e.preventDefault();
          handleChange({ [e.target.name]: e.target.value });
          handleSubmit();
        }}
        {...rest}>
        <option value="" hidden>
          {placeholder}
        </option>
        <option selected value={firstElem?.value}>
          {firstElem?.name}
        </option>
        {restElem?.map((item) => {
          return (
            <option key={item.value} value={item.value}>
              {item.name}
            </option>
          );
        })}
      </Form.Select>
    </div>
  );
}

export default CustomSelect;
